import { useCallback, useState } from 'react';
import { useUserInfo } from 'hooks/auth/useUserInfo';

const STORAGE_KEY_PREFIX = 'addProductWarningClickCount_';
const REPEAT_INTERVAL = 10;

// Show on the 1st "Add Product" click, then every 10th click thereafter: #1, #11, #21, #31...
const isDisplayTurn = (clickCount) =>
  (clickCount - 1) % REPEAT_INTERVAL === 0;

export const useAddProductWarningGate = () => {
  const { userId } = useUserInfo();

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [pendingAction, setPendingAction] = useState(null);

  const bumpClickCountAndCheck = () => {
    const storageKey = `${STORAGE_KEY_PREFIX}${userId ?? 'anonymous'}`;
    const nextCount = (Number(localStorage.getItem(storageKey)) || 0) + 1;
    localStorage.setItem(storageKey, String(nextCount));
    return isDisplayTurn(nextCount);
  };

  const guardAddProductClick = useCallback(
    (action) => () => {
      if (bumpClickCountAndCheck()) {
        setPendingAction(() => action);
        setIsModalVisible(true);
      } else {
        action?.();
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [userId]
  );

  const handleAcknowledge = () => {
    setIsModalVisible(false);
    pendingAction?.();
    setPendingAction(null);
  };

  const dismiss = () => {
    setIsModalVisible(false);
    setPendingAction(null);
  };

  return {
    isModalVisible,
    guardAddProductClick,
    handleAcknowledge,
    dismiss,
  };
};
